import { createAction, props } from '@ngrx/store';
import { withNameSpace } from './email-conversation.actions';
import { EmailMessage } from '../models/email-message.model';
import { Attachment } from 'common/store/genesys-cloud/conversations/emails/models/attachment.model';

export const loadEmailMessage = createAction(
  withNameSpace('Load Email Message'),
  props<{ conversationId: string, messageId: string }>()
);

export const emailMessageLoaded = createAction(
  withNameSpace('Email message loaded'),
  props<{ conversationId: string, emailMessage: EmailMessage }>()
);

export const sendEmailMessage = createAction(
  withNameSpace('Send Email Message'),
  props<{ conversationId: string, emailMessage: Partial<EmailMessage> }>()
);

export const sendEmailMessageSuccess = createAction(
  withNameSpace('Send Email Message Success'),
  props<{ conversationId: string, emailMessage: EmailMessage }>()
);

export const sendEmailMessageFailure = createAction(
  withNameSpace('Send Email Message Failure'),
  props<{ conversationId: string, errorMessage: string }>()
);

export const uploadAttachment = createAction(
  withNameSpace('Upload Attachment'),
  props<{ conversationId: string, form: FormData }>()
);

export const attachmentUploadSuccess = createAction(
  withNameSpace('Attachment Upload Success'),
  props<{ conversationId: string }>()
);

export const attachmentUploadFailure = createAction(
  withNameSpace('Attachment Upload Failure'),
  props<{ conversationId: string }>()
);

export const deleteAttachment = createAction(
  withNameSpace('Delete Attachment'),
  props<{ conversationId: string, attachmentMeta: Attachment }>()
);

export const attachmentDeleteSuccess = createAction(
  withNameSpace('Attachment Delete Success'),
  props<{ conversationId: string }>()
);

export const attachmentDeleteFailure = createAction(
  withNameSpace('Attachment Delete Failure'),
  props<{ conversationId: string }>()
);

export const updateEmailDraft = createAction(
  withNameSpace('Update Email Draft'),
  props<{ conversationId: string, draftMessage: Partial<EmailMessage> }>()
);

export const copyAttachment = createAction(
  withNameSpace('Copy Attachment'),
  props<{ conversationId: string, sourceMessageId: string, attachments: Attachment[] }>()
);
